import { TeacherActivityQuestion } from "./questions";

export const getTeacherActivitiesQueryKey = (userId?: number) =>
    ["teacherActivities", userId] as const;

export const getTeacherActivityQueryKey = (id: number) =>
    ["teacherActivities", id] as const;

export type TeacherActivityStatus = "NOT_STARTED" | "IN_PROGRESS" | "COMPLETED";

export const FEEDBACK_STATUSES = ["pending", "approved", "rejected"];

export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];

export interface TeacherActivity {
    id: number;
    activity_template_id: number;
    activity_template_name: string;
    activity_class: string;
    teacher_id: number;
    user_id: number;
    user_first_name: string;
    user_last_name: string;
    school_id: number;
    school_name: string;
    selected_skill_name: string;
    selected_subject_name: string;
    selected_location_name: string;
    selected_independency_level_name: string;
    activity_current_stage_index: number;
    activity_current_stage_started_timestamp: Date;
    activity_play_timestamps: Date[];
    activity_pause_timestamps: Date[];
    activity_status: TeacherActivityStatus;
    reflection_questions: TeacherActivityQuestion[];
    reflection_stages_names: string[];
    reflection_groups_stages: number[];
    reflection_sent_at: Date;
    feedback_questions: TeacherActivityQuestion[];
    feedback_notes: string;
    feedback_rank: number;
    feedback_status: FeedbackStatus;
    feedback_sent_at: Date;
    created_at: Date;
    updated_at: Date;
    completed_at: Date;
}

export interface TeacherActivityPreview {
    activity_template_id: number;
    activity_template_name: string;
    activity_class: string;
    user_first_name: string;
    user_last_name: string;
    completed_at: Date;
}

export function groupByTemplateId(
    teacherActivities: TeacherActivity[]
): { activityTemplateId: number; templateActivities: TeacherActivity[] }[] {
    return Object.entries(
        teacherActivities.reduce((acc, activity) => {
            acc[activity.activity_template_id] = [
                ...(acc[activity.activity_template_id] || []),
                activity,
            ];
            return acc;
        }, {} as Record<number, TeacherActivity[]>)
    ).map(([activityTemplateId, activities]) => ({
        activityTemplateId: Number(activityTemplateId),
        templateActivities: activities,
    }));
}
